<template>
  <footer>
    <section class="apps">
      <div><img class="elvas-mobile-image unselectable" src="@/assets/app-phone-screen-png.png"></div>
      <div class="text-container">
        <p class="title">APP IOS E ANDROID</p>
          <p class="text">Agora ainda é mais fácil de conhecer Elvas! 
            Faça já o download da nossa aplicação móvel.</p>
          <section class="unselectable">
            <div><img src="@/assets/playstore-2-x-8.png"></div>
            <div><img src="@/assets/appstore-2-x-8.png"></div>
          </section>
      </div>
    </section>
    <div class="middle">
      <div>
        <h5>Patrimonio</h5>
        <router-link to="/patrimonio">Historia</router-link>
        <router-link to="/patrimonio">Estórias e Segredos</router-link>
        <router-link to="/patrimonio">Gastronomia</router-link>
      </div>
      <div>
        <h5>Pontos de Interesse</h5>
        <router-link to="/pontosDeInteresse?type=onde_comer">Onde Comer</router-link>
        <router-link to="/pontosDeInteresse?type=onde_dormir">Onde Dormir</router-link>
        <router-link to="/pontosDeInteresse?type=o_que_visitar">O que Visitar</router-link>
        <router-link to="/pontosDeInteresse?type=onde_comprar">Onde Comprar</router-link>
      </div>
      <div>
        <h5>Eventos & Actividades</h5>
        <router-link to="/eventosActividade">Agenda Cultural</router-link>
        <router-link to="/eventosActividade">O que Fazer?</router-link>
      </div>
      <div v-if="paths">
        <h5>Mapa & Percursos</h5>
        <router-link v-for="path in paths" :key="path.id" :to="'/percurso/' + path.id">
          {{path.translation && path.translation.title}}
        </router-link>
      </div>
      <div>
        <h5>Informação Geral</h5>
        <router-link to="/informacaoGeral">Como Chegar?</router-link>
        <router-link to="/informacaoGeral">Visitas Guiadas</router-link>
        <router-link to="/informacaoGeral">Meteorologia</router-link>
        <router-link to="/informacaoGeral">Feriados e Festas</router-link>
        <router-link to="/informacaoGeral">Farmácias</router-link>
      </div>
      <div>
        <router-link to="/estalagem"><h5>Hotel D. Sancho II</h5></router-link>
        <router-link to="/estalagem"><h5>O Dourando - Restaurante</h5></router-link>
      </div>
    </div>
    <section class="copyright-policies">
      <div>
        <img class="ohelvas-icon" src="@/assets/icon-simple.svg">
        <p>© 2020 Oh Elvas. All Rights Reserved.</p>
      </div>
      <div>
        <router-link :to="{name: 'politicaPrivacidadeECookies'}">Politica de privacidade</router-link>
        <router-link :to="{name: 'politicaPrivacidadeECookies'}">Política de Cookies</router-link>
      </div>
      <div><img src="@/assets/logo-portugal-2020-branco.png"></div>
    </section>
  </footer>
</template>

<script>
export default {
  name: 'footer',
  props: {
  },
  data () {
    return {
      paths: null
    }
  },
  async mounted () {
    this.paths = await this.api.get('path')
  }
}
</script>
<style scoped lang="scss">
a {
  text-decoration: none;
  color: black;
}
footer {
  padding: 150px 0 0 0;
  background: #a79374;
  color: white;
  margin-top: 0;
  position: relative;
  z-index: 10;
  .apps {
    position: relative;
    width: calc(80% - 140px);
    margin: 0 10%;
    background: #dfcfb6;
    box-shadow: 0 24px 40px 0 rgba(0, 0, 0, 0.32);
    color: black;
    margin-top: -225px;
    z-index: 1;
    padding: 40px 70px;
    display: flex;
    .title {
      font-family: 'Barlow Condensed';
      font-size: 24px;
      font-weight: 500;
      font-stretch: condensed;
      font-style: normal;
      line-height: 1.08;
      letter-spacing: 0.6px;
      margin-bottom: 16px;
    }
    .text {
      font-size: 42px;
      font-weight: bold;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.5px;
    }
    & > .text-container {
      display: flex;
      flex-direction: column;
      margin-top: 40px;
      margin-left: 80px;
      margin-right: 80px;
      section {
        display: flex;
        margin-top: 40px;
        img {
          margin-right: 50px;
        }
      }
    }

    @media (max-width: 1100px){
      padding: 32px;
      width: calc(80% - 60px);
      overflow: hidden;

      .text-container {
        width: 100%;
        overflow: hidden;
        margin-right: 0;
        margin-left: 40px;

        section {
          display: flex;
          margin-top: 40px;
          img {
            margin-right: 20px;
          }
        }
      }
      .text {
        font-size: 28px;
      }
    }

    @media (max-width: 900px){ 
      width: calc(100vw - 64px);
      margin-left: auto;
      margin-right: auto;
      padding: 16px;

      .elvas-mobile-image {
        width: 200px;
      }

      .text-container section {
          display: flex;
          margin-top: 40px;

          img {
            width: 150px;
            height: 50px;
            margin-right: 20px;
          }
        }
    }

    @media (max-width: 700px){ 
    width: calc(100vw - 76px);
    padding: 16px 32px 16px 16px;

      .elvas-mobile-image {
        width: 124px;
        height: 213px;
      }

      .text-container {
        margin-top: 20px;
        .text {
          font-size: 18px;
        }
        section {
          display: flex;
          margin-top: 20px;
          img {
            width: 76px;
            height: 23px;
            margin-right: 20px;
          }
        }
      } 
    }

    @media (max-width: 500px){ 
      .text-container {
        margin-left: 16px;
        .text {
          font-size: 14px;
        }

        section {
          img {
            margin-right: 12px;
          }
        }
      } 
    }
  }
  .middle {
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    padding: 0 5%;
    div {
      width: calc(100% / 3);
      padding: 40px 0;
      h5 {
        font-weight: bold;
        margin-bottom: 20px;
        font-size: 16px;
        color: #eee3d4;
      }
      p, a {
        color: white;
        display: block;
        margin: 7.5px 0;
        margin-left: 20px;
        font-size: 16px;
      }
    }

    @media (max-width: 700px){
        div {
        width: calc(100% / 2);
      }
    }

    @media (max-width: 500px){
      div {
        width: calc(100%);
        padding: 0;
        margin-bottom: 32px;

          p, a {
          margin: 12px 0;
          margin-left: 12px;
          font-size: 16px;
          font-family: Sen;
        }

        p:last-child, a:last-child  {
          margin-bottom: 0;
        }
      }
    }
  }

  .copyright-policies {
    padding: 25px 5%;
    border-top: 1px solid rgba(228, 230, 234, 0.25);
    display: flex;
    align-items: center;
    div {
      width: calc(100% / 3);
      &:first-of-type {
        display: flex;
        align-items: center;
      }
      &:nth-of-type(2) {
        a {
          margin-top: 5px;
        }
      }
      img {
        margin-right: 20px;
      }
    }
    a {
      color: white;
      display: block;
    }

    @media (max-width: 700px){
      margin-right: 8px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
      div {
        width: 100%;
      }
    }

    @media (max-width: 500px){
      margin-right: 8px;
      display: flex;
      flex-direction: column-reverse;
      gap: 48px;
      div {
        width: 100%;

        &:nth-child(2){
          a + a {
            margin-top: 24px; 
          }
        }
      }
    }
  }
}
</style>
